import React, { useEffect, useRef, useState } from "react";
import { Badge, Button, Form as BTForm, Modal, Spinner } from "react-bootstrap";
import axios from "../../../config/axios";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import FormInputText from "../../../components/Forms/FormInputText";
import FormSelectBox from "../../../components/Forms/FormSelectBox";
import GeneralFormError from "src/components/Forms/GeneralFormError";

const EditInvoicePaymentDialog = ({ handleSubmit, handleClose, payment }) => {
  const [editPayment, setEditPayment] = useState();
  const [invoice, setInvoice] = useState();
  const { t } = useTranslation("dashboard");
  const formRef = useRef();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`api/v1/invoices/${payment.invoice_id}/payments/template.json`)
      .then(({ data }) => {
        setEditPayment({ ...data, ...payment });

        axios.get(`api/v1/invoices/${payment.invoice_id}`).then(({ data }) => {
          setInvoice(data);
          setLoading(false);
        });
      });
  }, []);

  function submit(values, helpers) {
    helpers.setSubmitting(true);

    let request;

    let updatedValues = { ...values };

    if (!values.fiscal_printed) {
      updatedValues.fiscal_printed_at = null;
    } else {
      updatedValues.fiscal_printed_at = new Date();
    }

    if (payment.id) {
      request = axios.put(
        `/api/v1/invoices/${editPayment.invoice_id}/payments/${payment.id}.json`,
        { payment: updatedValues }
      );
    } else {
      request = axios.post(
        `/api/v1/invoices/${editPayment.invoice_id}/payments.json`,
        { payment: updatedValues }
      );
    }

    request
      .then(({ data }) => {
        setEditPayment(data);
        handleSubmit(data);
      })
      .catch((error) => {
        helpers.setErrors(error.response.data);
      })
      .finally(() => {
        helpers.setSubmitting(false);
      });
  }

  return (
    <Modal
      show={true}
      onHide={handleClose}
      dialogClassName={"invoice-payments-dialog"}
    >
      <Modal.Header closeButton>
        <Modal.Title>Zahlung</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <Spinner
            className={"d-block mx-auto"}
            animation="border"
            variant="primary"
          />
        ) : (
          <Formik
            innerRef={formRef}
            initialValues={{
              ...editPayment,
              fiscal_printed: !!editPayment.fiscal_printed_at,
            }}
            enableReinitialize={true}
            onSubmit={submit}
          >
            {({ values, setFieldValue, errors }) => (
              <Form>
                <GeneralFormError errors={errors} />

                {values.stripe_payment_intent_id && (
                  <FormInputText
                    name={"stripe_payment_intent_id"}
                    label={"Stripe ID"}
                    disabled={true}
                  />
                )}
                <FormInputText
                  name={"amount"}
                  label={"Betrag"}
                  placeholder={"100"}
                  hint={
                    <div>
                      <a
                        href={"#"}
                        onClick={() =>
                          setFieldValue("amount", invoice.open_amount)
                        }
                      >
                        Offene Summe laden
                      </a>
                    </div>
                  }
                />
                <FormSelectBox
                  name={"type_of"}
                  label={"Typ"}
                  options={editPayment?.configuration?.type_ofs}
                />
                <FormSelectBox
                  name={"type_of"}
                  label={"Typ"}
                  options={editPayment?.configuration?.type_ofs}
                />
                <FormSelectBox
                  name={"payment_type"}
                  label={"Zahlungsmethode"}
                  options={editPayment?.configuration?.payment_types}
                />
                <FormInputText
                  type={"datetime-local"}
                  name={"paid_at"}
                  label={"Bezahlt am"}
                  placeholder={"Zahlungsdatum"}
                />
              </Form>
            )}
          </Formik>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t("common:components.button.close")}
        </Button>
        <Button
          onClick={() => formRef.current.handleSubmit()}
          disabled={formRef?.current?.isSubmitting}
        >
          {t("common:components.button.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditInvoicePaymentDialog;
